import type { CompanySelectionTypes } from '@revelio/core';

import MappingStepWithState from '../company-selection/company-mapping/upload-companies/mapping-step-with-state';
import type { BaseStepsInterface } from '../data-enrichment/types/dataEnrichmentTypes';
import { SnowflakeInputsWithContext } from './snowflake-inputs';
import SnowflakeMapperConfirmation from './snowflake-mapper-confirmation';
import {
  SnowflakeMapperProvider,
  useSnowflakeMapperStore,
} from './snowflake-mapper-context';
import SnowflakeMapperModal from './snowflake-mapper-modal';

interface SnowflakeCompaniesMapperStepProps {
  setCompanyColumnSelectionModalOpen: React.Dispatch<
    React.SetStateAction<CompanySelectionTypes | null>
  >;
}

export const SnowflakeCompanyMapperSteps = ({
  setCompanyColumnSelectionModalOpen,
}: SnowflakeCompaniesMapperStepProps) => {
  const baseSteps: BaseStepsInterface[] = [
    {
      title: 'Snowflake Table',
      description: '',
      content: () => <SnowflakeInputsWithContext />,
    },
    {
      title: 'Map Columns',
      description: '',
      content: () => (
        <MappingStepWithState
          useUploadStore={useSnowflakeMapperStore}
          Modal={SnowflakeMapperModal}
        />
      ),
    },
    {
      title: 'Confirmation',
      description: '',
      content: () => (
        <SnowflakeMapperConfirmation
          setCompanyColumnSelectionModalOpen={
            setCompanyColumnSelectionModalOpen
          }
        />
      ),
    },
  ];

  return (
    <SnowflakeMapperProvider baseSteps={baseSteps}>
      <SnowflakeMapperActiveStep />
    </SnowflakeMapperProvider>
  );
};

const SnowflakeMapperActiveStep = () => {
  const activeStep = useSnowflakeMapperStore((state) => state.activeStep);
  const steps = useSnowflakeMapperStore((state) => state.steps);

  // @ts-expect-error noUncheckedIndexedAccess
  return steps[activeStep].content();
};
